<h2 mat-dialog-title *ngIf="editStorageType.id === undefined"><i class="fas fa-plus me-2"></i>Create Storage Type</h2>
<h2 mat-dialog-title *ngIf="editStorageType.id !== undefined"><i class="fas fa-plus me-2"></i>Edit Storage Type for {{ editStorageType.name }}
</h2>
<mat-dialog-content class="mat-typography">
  <form #StorageTypeForm="ngForm" id="StorageTypeForm" name="StorageTypeForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="name"
              name="name"
              [(ngModel)]="editStorageType.name"
              placeholder="Name"
              required
              #name="ngModel"
            />
          </mat-form-field>
          
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="description"
              name="description"
              [(ngModel)]="editStorageType.description"
              placeholder="Description"
              required
              #description="ngModel"
            />
          </mat-form-field>
         
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <input
              type="text"
              matInput
              id="integrationId"
              name="integrationId"
              [(ngModel)]="editStorageType.integrationId"
              placeholder="Integration Id"
              #integrationId="ngModel"
            />
          </mat-form-field>
        </div>
      </div>
      @if (editStorageType.id === undefined) {
        <div class="col-md-6 d-flex align-items-center">
         <mat-checkbox
           name="isActive"
           id="isActive"
           [(ngModel)]="editStorageType.isActive"
           color="primary"
         >
           Active
         </mat-checkbox>
       </div>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
   <div class="custom-dialog-actions">
    <div class="btn-group">
      <button *ngIf="!submitting" type="submit" form="StorageTypeForm" class="custom-button save-button"
        [disabled]="StorageTypeForm.invalid" (click)="onSubmit()">
        <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save
      </button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="custom-button cancel-button" (click)="cancelClicked(StorageTypeForm, false)">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button>
    </div>
   
  </div>
</mat-dialog-actions>
